import { SnowboardIcon } from './SnowboardIcon';

/**
 * author: Google
 * id C2A03E16-166E-4FAA-A5DB-462CE38C44FE
 * name snowboard
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowboard.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanSnowboardIcon = SnowboardIcon;
export default HumanSnowboardIcon